import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import ALLRoutes from "./feature-module/router/router";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter, useLocation } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import { Provider } from "react-redux";
import store from "./core/redux/store";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { initGA, logPageView } from "./utils/analytics";
import { Analytics } from "@vercel/analytics/react";

// Initialize Google Analytics
initGA();

// Track page views
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

// Preserve ?lang=bn in URL on every navigation
function LangParamPreserver() {
  const location = useLocation();

  useEffect(() => {
    const stored = localStorage.getItem("lang");
    if (!stored || stored === "en") return;
    const params = new URLSearchParams(location.search);
    if (params.get("lang") !== stored) {
      params.set("lang", stored);
      window.history.replaceState(null, "", location.pathname + "?" + params.toString() + location.hash);
    }
  }, [location.pathname]);

  return null;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={base_path}>
      <Provider store={store}>
        <AuthProvider>
          <AnalyticsTracker />
          <LangParamPreserver />
          <ALLRoutes />
          {/* Vercel Web Analytics: visitors + page views, only sends data on the deployed site */}
          <Analytics />
        </AuthProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
